<script setup>
import { onMounted } from "vue";
import useSupplierTable from "./hooks/useSupplierTable";
import adjust from "./adjust.vue";
import { SUPPLIER_STATUS } from "@/constants";

const {
  searchRef,
  adjustRef,
  searchData,
  tableLoading,
  columns,
  tableData,
  pages,
  getList,
  handleSizeChange,
  handleCurrentChange,
  handleReset,
  handleAdjust,
  handleDelete,
  handleDisabled,
} = useSupplierTable();

onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '供应商管理' }">
    <template #header-btn>
      <el-button type="primary" icon="Plus" @click="handleAdjust(null, 'add')"
        >新增</el-button
      >
    </template>
    <template #search>
      <el-form :model="searchData" ref="searchRef">
        <el-row :gutter="8">
          <el-col :span="4">
            <el-form-item label="供应商编号" prop="number">
              <el-input
                v-model="searchData.number"
                placeholder="请输入供应商编号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="供应商名称" prop="name">
              <el-input
                v-model="searchData.name"
                placeholder="请输入供应商名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="状态" prop="status">
              <el-select v-model="searchData.status" placeholder="请选择状态">
                <el-option
                  v-for="item in SUPPLIER_STATUS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button type="primary" icon="Search" @click="getList()"
                >查询</el-button
              >
              <el-button icon="Refresh" @click="handleReset()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        v-loading="tableLoading"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <el-tag
                v-if="item.prop == 'status'"
                :type="row[item.prop]?.value == '1' ? 'success' : 'danger'"
                >{{ row[item.prop]?.desc }}</el-tag
              >
              <span v-else>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="200">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleAdjust(row, 'detail')"
              >详情</el-button
            >
            <el-button type="primary" link @click="handleAdjust(row, 'edit')"
              >编辑</el-button
            >
            <el-button type="danger" link @click="handleDelete(row)"
              >删除</el-button
            >
            <el-button
              :type="row.status.value == '1' ? 'danger' : 'success'"
              link
              @click="handleDisabled(row)"
              >{{ row.status.value == "1" ? "禁用" : "启用" }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top: 10px"
        :current-page="pages.page"
        :page-size="pages.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pages.total"
        layout="->, total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </template>
  </zh-table-page>
  <!-- 编制组件 -->
  <adjust ref="adjustRef" @after-save="getList" />
</template>

<style lang="scss" scoped></style>
